import React, { useState } from 'react';
import { useEffect } from 'react';
import DateRangePicker from '../DateRangePicker/DateRangePicker';
import ButtonGroup from '../ButtonGroup/ButtonGroup';

const DateRangeFilter = ({ selectedFromDate, selectedToDate,onApplyDateFilter, onClearFilter }) => {
  const [fromDate, setFromDate] = useState(selectedFromDate);
  const [toDate, setToDate] = useState(selectedToDate);

  useEffect(() => {
    setFromDate(selectedFromDate);
    setToDate(selectedToDate);
  }, [selectedFromDate, selectedToDate]);

  const handleApply = () => {
    onApplyDateFilter(fromDate, toDate);
  };

  const handleClear = () => {
    setFromDate(null);
    setToDate(null);
    onClearFilter();
  };

  const buttons = [
    {
      buttonText: "Clear",
      onClick: handleClear,
      buttonType: "outlined",
      buttonColor: "#A62B23",
      textColor: "#A62B23",
    },
    {
      buttonText: "Apply",
      onClick: handleApply,
      buttonType: "filled",
      buttonColor: "#A62B23",
      textColor: "#fff",
    }
  ];
  const containerStyle = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    boxShadow: '1px 1px 1px 1px rgba(0,0,0,0.1)',
  };
  return (
    <div style ={ containerStyle}>
      <DateRangePicker
        fromDate={fromDate}
        toDate={toDate}
        onFromDateChange={setFromDate}
        onToDateChange={setToDate}
      />
      <ButtonGroup buttons={buttons} />
    </div>
  );
};

export default DateRangeFilter;
